export default __webpack_public_path__ + "static/media/arrow-right.6e8ede82.svg";